import { render, staticRenderFns } from "./ItemRow.vue?vue&type=template&id=3aaacf1a&scoped=true&"
import script from "./ItemRow.vue?vue&type=script&lang=js&"
export * from "./ItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ItemRow.vue?vue&type=style&index=0&id=3aaacf1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaacf1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
